import { canConsolidate } from "./index59.js";
import { createMatrix } from "./index150.js";
import { findIndicesInMatrix } from "./index151.js";
import { mergeRows } from "./index157.js";
import { updateIndexMap } from "./index159.js";
function consolidateSpaces(requiredSpaces) {
  const abstractSpaces = [];
  const consolidationSpaces = [];
  for (const space of requiredSpaces.keys()) {
    if (!space.consolidationType) {
      for (let i = 0; i < requiredSpaces.get(space); i++) {
        abstractSpaces.push({ space });
      }
    } else {
      consolidationSpaces.push(space);
    }
  }
  const { matrix, indexMap } = createMatrix(abstractSpaces, (spaceA, spaceB) => canConsolidate(spaceA.space, spaceB.space, consolidationSpaces));
  let currentItem = -1;
  let indices = findIndicesInMatrix(matrix, (item) => {
    if (item !== null && item >= 0) {
      currentItem = item;
      return true;
    } else
      return false;
  });
  while (indices.i !== -1 && indices.j !== -1) {
    const func = (itemA, itemB) => {
      if (itemA === -1 || itemB === -1) {
        return -1;
      } else if (itemA === currentItem || itemB === currentItem) {
        return currentItem;
      } else
        return -1;
    };
    mergeRows(matrix, indices.i, indices.j, func, null);
    updateIndexMap(indexMap, indices.i, indices.j, (spaceA, spaceB) => merge(spaceA, spaceB, consolidationSpaces[currentItem]));
    indices = findIndicesInMatrix(matrix, (item) => {
      if (item !== null && item >= 0) {
        currentItem = item;
        return true;
      } else
        return false;
    });
  }
  return removeEmptyConsolidationSpaces(indexMap);
}
function merge(spaceA, spaceB, consolidationSpace) {
  if (spaceA.space.consolidationType || spaceB.space.consolidationType) {
    const mergedSpace = spaceA.space.consolidationType ? spaceA : spaceB;
    const spaceToMerge = spaceA.space.consolidationType ? spaceB : spaceA;
    const includes = [];
    if (mergedSpace.includes)
      includes.push(...mergedSpace.includes);
    if (spaceToMerge.includes)
      includes.push(...spaceToMerge.includes);
    else
      includes.push(spaceToMerge.space);
    return {
      space: mergedSpace.space,
      includes
    };
  } else {
    return {
      space: consolidationSpace,
      includes: [spaceA.space, spaceB.space]
    };
  }
}
function removeEmptyConsolidationSpaces(spaces) {
  const newSpaces = [];
  for (const space of spaces) {
    if (space.space.consolidationType && (!space.includes || space.includes.length === 0))
      continue;
    if (space.space.consolidationType && space.includes && space.includes.length === 1) {
      const newSpace = {
        space: space.includes[0]
      };
      newSpaces.push(newSpace);
      continue;
    }
    newSpaces.push(space);
  }
  return newSpaces;
}
export {
  consolidateSpaces
};
//# sourceMappingURL=index60.js.map
